// frontend/src/components/MD3Switch.js
import React from 'react';

const MD3Switch = ({ checked, onChange, disabled, color = 'primary' }) => {
    const colorClasses = {
        primary: 'peer-checked:bg-primary',
        secondary: 'peer-checked:bg-secondary',
        tertiary: 'peer-checked:bg-tertiary',
        error: 'peer-checked:bg-error',
    };

    return (
        <label className="relative inline-flex items-center cursor-pointer group">
            <input
                type="checkbox"
                className="sr-only peer"
                checked={checked}
                onChange={onChange}
                disabled={disabled}
            />
            <div className={`
        w-14 h-8 
        bg-surface-containerHighest 
        rounded-full 
        transition-all duration-medium1 
        peer-focus:outline-none 
        peer-disabled:opacity-50 
        group-hover:bg-surface-on/[0.12]
        after:content-[''] 
        after:absolute after:top-[4px] after:left-[4px] 
        after:bg-surface-onVariant 
        after:rounded-full 
        after:h-6 after:w-6 
        after:transition-all after:duration-medium2 after:ease-emphasized
        peer-checked:after:translate-x-6 
        peer-checked:after:bg-surface-on
        ${colorClasses[color] || colorClasses.primary}
      `}></div>
        </label>
    );
};

export default MD3Switch;
